import React from 'react';
import styles from '@/styles/PEIRecordsInfo.module.scss';

export const PEIRecordsInfo = ({
  start,
  end,
  institutionName,
  componentName = 'contacts',
}: {
  institutionName: string | undefined;
  start: number | undefined;
  end: number | undefined;
  componentName: string | undefined;
}) => {
  return (
    <span className={styles.footer} data-testid='component-record-info-id'>
      Showing {start} of {end} {institutionName} {componentName}
    </span>
  );
};
